import { useLesson } from '../../lessons';
import ThumbnailImage from './ThumbnailImage';
import { useTrack } from '../../tracks';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackThumbnail = ({
  trackId,
  language
}) => {
  const {
    track
  } = useTrack(trackId, language);
  const {
    previewThumbnailSquareUrl,
    name
  } = track || {};
  return /*#__PURE__*/_jsx(ThumbnailImage, {
    name: name,
    src: previewThumbnailSquareUrl
  });
};
const LessonThumbnail = ({
  lessonId,
  language
}) => {
  const {
    lesson
  } = useLesson(lessonId, language);
  const {
    previewThumbnailSquareUrl,
    name
  } = lesson || {};
  return /*#__PURE__*/_jsx(ThumbnailImage, {
    name: name,
    src: previewThumbnailSquareUrl
  });
};
const ThumbnailItem = ({
  lessonId,
  trackId,
  language
}) => {
  if (lessonId) return /*#__PURE__*/_jsx(LessonThumbnail, {
    language: language,
    lessonId: lessonId
  });
  if (trackId) return /*#__PURE__*/_jsx(TrackThumbnail, {
    language: language,
    trackId: trackId
  });
  return null;
};
export default ThumbnailItem;